import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col-reverse gap-28 gap-x-80 self-center justify-self-center py-[3.75rem] tablet:mt-[8.75rem] tablet:flex-row tablet:justify-center tablet:self-start tablet:pt-0" }
const _hoisted_2 = { class: "tablet:w-full tablet:max-w-[24.25rem]" }
const _hoisted_3 = { class: "h6 tablet:h5" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "mt-40 flex flex-col gap-y-8 border border-black-300 p-16 tablet:p-24" }
const _hoisted_7 = { class: "text-22 font-medium tablet:text-26" }
const _hoisted_8 = { class: "flex items-center justify-between py-8 text-16" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "flex items-center justify-between border-t border-black-300 pt-16 text-18 font-medium" }
const _hoisted_11 = { class: "mt-20 flex flex-col gap-y-12 tablet:mt-24" }
const _hoisted_12 = {
  key: 0,
  class: "text-16 text-red"
}
const _hoisted_13 = { class: "tablet:w-full tablet:max-w-[25.75rem]" }
const _hoisted_14 = { class: "text-22 tablet:text-26" }
const _hoisted_15 = { class: "flex items-center gap-x-12" }
const _hoisted_16 = { class: "text-14 text-black-400 tablet:text-18" }
const _hoisted_17 = { class: "overflow-hidden" }
const _hoisted_18 = { class: "flex items-center gap-x-16 py-16" }
const _hoisted_19 = { class: "flex flex-col gap-y-8 text-14 font-medium" }
const _hoisted_20 = { class: "block py-16 text-16 tablet:py-24" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString($data.locale.title), 1),
      ($data.locale.instructions)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "mt-8 max-w-prose text-14 text-black-700 tablet:text-16",
            innerHTML: $data.locale.instructions
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      ($data.locale.customer_advisory)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: "mt-8 max-w-prose text-14 text-black-700 tablet:text-16",
            innerHTML: $data.locale.customer_advisory
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString($data.locale.summary), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString($data.locale.subtotal), 1),
          _createElementVNode("span", null, _toDisplayString($options.formattedPrice($options.subtotal * 100)), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString($data.locale.total), 1),
          _createElementVNode("span", null, _toDisplayString($options.formattedPrice($options.total * 100)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        ($data.postStatus === 'ERROR')
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($data.locale.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-primary btn-small w-full text-center text-18", {loading: $data.postStatus === 'LOADING'}]),
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.requestReturn && $options.requestReturn(...args)))
        }, _toDisplayString($data.locale.confirm_button), 3),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-small w-full border-2 border-black-900 text-center text-18",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('updateModal', 'OPENED', 'CANCEL_REQUEST')))
        }, _toDisplayString($data.locale.cancel_button), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center justify-between border-b border-t border-black-300 px-16 py-12 tablet:pointer-events-none tablet:p-24",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('toggleItemsDropdown')))
      }, [
        _createElementVNode("span", _hoisted_14, _toDisplayString($data.locale.your_return), 1),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, [
            _createTextVNode(_toDisplayString($props.itemsToReturn.length) + " ", 1),
            ($props.itemsToReturn.length > 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString($data.locale.item_count_plural), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString($data.locale.item_count), 1)
                ], 64))
          ]),
          (_openBlock(), _createElementBlock("svg", {
            width: "14",
            height: "10",
            viewBox: "0 0 16 10",
            fill: "none",
            class: _normalizeClass(["transition-transform duration-200 ease-in-out tablet:hidden", {'rotate-180': $props.itemsDropdownStatus === 'OPENED'}])
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("path", {
              d: "M1.25 1.625L8 8.375L14.75 1.625",
              stroke: "#121212",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]), 2))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["grid transition-grid-template-rows duration-500 tablet:grid-rows-1", $props.itemsDropdownStatus === 'OPENED' ? 'grid-rows-1' : 'grid-rows-0'])
      }, [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.itemsToReturn, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.uniqueKey,
              class: "border-b border-black-300"
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_v_image, {
                  lazyloaded: "",
                  source: item.imageUrl,
                  alt: "",
                  width: 150,
                  class: "aspect-return-portal-item h-full w-full max-w-[4.8125rem] object-cover object-center"
                }, null, 8, ["source"]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1),
                  _createElementVNode("span", null, _toDisplayString($options.formattedPrice(item.price * 100)), 1)
                ])
              ]),
              _createElementVNode("span", _hoisted_20, [
                _createTextVNode(_toDisplayString($data.locale.return_reason) + " ", 1),
                (item.reason)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(item.reason), 1)
                    ], 64))
                  : (item.otherReason)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(item.otherReason), 1)
                      ], 64))
                    : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ], 2)
    ])
  ]))
}